import './index.css';

const ItemButtonsContainer = ({ children }) => {
    return (
        <div className="item-buttons-container">
            {children}
        </div>
    )
}

export default ItemButtonsContainer;